export enum Pages {
  HP = 'HP',
  SRP = 'SRP',
  AP = 'AP',
  PP = 'PP',
  CP = 'CP',
  BM = 'BM',
  MB = 'MB',
  NPS = 'NPS'
}

export enum EndpointNames {
  Rooms = 'Rooms',
  RoomsPolling = 'RoomsPolling',
  Hotel = 'Hotel',
  HotelV2 = 'HotelV2',
  OfferCheck = 'OfferCheck',
  BookingCreation = 'BookingCreation',
  BookingCreationAsync = 'BookingCreationAsync',
  BookingFinalisation = 'BookingFinalisation',
  AlgoliaLov = 'AlgoliaLov',
  AlgoliaHotel = 'AlgoliaHotel',
  BookingStatus = 'BookingStatus',
  Offers = 'Offers',
  SapiAnchor = 'SapiAnchor',
  AlternativeAvailability = 'AlternativeAvailability',
  Search = 'Search',
  Bookings = 'Bookings',
  DealFreezeOffers = 'DealFreezeOffers',
  DealFreezeBookings = 'DealFreezeBookings',
  DealFreezeUserLimits = 'DealFreezeUserLimits',
  SbOfferCheck = 'SbOfferCheck',
  BookingRetrieve = 'BookingRetrieve',
  OtpRequest = 'OtpRequest',
  OtpVerify = 'OtpVerify',
  FAQ = 'FAQ',
  PriceInsights = 'PriceInsights',
  PriceInsightsHistory = 'PriceInsightsHistory',
  PaymentSettings = 'PaymentSettings',
  PayrailsSession = 'PayrailsSession'
}

export enum RequestMethod {
  GET = 'get',
  POST = 'post',
  PUT = 'put'
}
